import React from 'react';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const logos = [
  '/rollingslides/WhatsApp Image 2025-07-22 at 20.06.40.jpeg',
  '/rollingslides/download-1.png',
  '/rollingslides/download.jpg',
  '/rollingslides/download.png',
  '/rollingslides/favicon.jpg',
  '/rollingslides/hicaps-logo-1.png',
  '/rollingslides/medipass-blog-2.png',
  '/rollingslides/skimble-workout-trainer-certification-logo-s-australian-strength-and-conditioning-association-asca-cpt-iphone.jpg',
  '/rollingslides/sports-medicine-australia-logo.jpg',
  '/slides/WhatsApp Image 2025-07-23 at 15.14.18.jpeg',
];

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const SliderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.background.default,
  padding: theme.spacing(4, 0),
  position: 'relative',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    width: '100px',
    height: '100%',
    zIndex: 2,
  },
  '&::before': {
    left: 0,
    background: `linear-gradient(to right, ${theme.palette.background.default} 0%, transparent 100%)`,
  },
  '&::after': {
    right: 0,
    background: `linear-gradient(to left, ${theme.palette.background.default} 0%, transparent 100%)`,
  },
}));

const SliderTrack = styled(Box)({
  display: 'flex',
  animation: `${scroll} 40s linear infinite`,
  width: 'fit-content',
});

const LogoItem = styled(Box)(({ theme }) => ({
  height: '80px',
  padding: theme.spacing(0, 4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  '& img': {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
    opacity: 0.9,
    transition: 'all 0.3s ease',
    '&:hover': {
      opacity: 1,
    },
  },
}));

const LogoSlider: React.FC = () => {
  const duplicatedLogos = [...logos, ...logos];

  return (
    <SliderContainer>
      <SliderTrack>
        {duplicatedLogos.map((logo, index) => (
          <LogoItem key={index}>
            <img src={logo} alt={`Partner logo ${index % logos.length + 1}`} />
          </LogoItem>
        ))}
      </SliderTrack>
    </SliderContainer>
  );
};

export default LogoSlider;